import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const Story = () => {
  return (
    <>
      <div
        style={{
          backgroundImage:
            "linear-gradient(179deg, #07070B 41.56%, #2B2D41 101.56%)",
        }}
      >
        <div className="missionContainer" style={{ padding: "100px 60px 0px 60px" }}>
          <div
          className="missionMainOne"
            style={{
              display: "flex",
              alignItems: "flex-start",
            }}
          >
            <div className="missionOne" style={{width:"100%"}}>
              <img
              className="missionOne" 
                src="../images/MissionOne.png"
                style={{ height:"100%",width:"400px" }}
              ></img>
            </div>
            <div className="missionTwo">
              <div
              className="missionTextOne"
                style={{
                  fontStyle: "italic",
                  fontSize: "40px",
                  color: "white",
                  marginLeft: 5,
                  fontFamily: "Didot",
                }}
              >
                Welcome to Bond,
              </div>
              <div
              className="missionTextTwo"
                style={{
                  fontStyle: "italic",
                  fontSize: "40px",
                  color: "white",
                  marginLeft: "60px",
                  fontFamily: "Didot",
                }}
              >
                where the ordinary isn’t an option
              </div>
            </div>
          </div>

          <Row
          className="missonRow"
            style={{
              position: "relative",
              top: "-70px",
            }}
          >
            <Col
              md={2}
              style={{
                padding: "0px",
              }}
            ></Col>
            <Col
              md={10}
              style={{
                padding: "0px",
              }}
            >
              <div
              className="missionMainTwo"
                style={{
                  display: "flex",
                }}
              >
                <div
                className="missionThree"
                  style={{
                    display: "flex",
                    alignItems: "start",
                    marginRight: 25,
                  }}
                >
                  {" "}
                  <img src="../images/MissionTwo.png"></img>
                </div>
                <div
                className="missionFour"
                  style={{
                    fontSize: "24px",
                    color: "white",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div>
                  Bond was created by a couple who wanted to experience California once the Covid restrictions were lifted. 
                   
                  </div>
                  <div  style={{
                      margin: "30px 0px 0px 0px",
                    }}>
                  After two years of not going out, the process of transitioning back to normalcy proved to be unreliable with fake reviews, incorrect hours listed, outdated menus and unfortunately many closed businesses. 
                    </div>
                  <div  style={{
                      margin: "30px 0px 0px 0px",
                    }}>
                  Planning the date night takes too much time and effort. Finding the coolest spots has become a nightmare to navigate.
                  </div>
                  <div
                    style={{
                      margin: "30px 0px",
                    }}
                  >
                Bond was created.
                  </div>
                  <div  style={{
                      marginBottom: "30px",
                    }}>
                    {" "}
                    A subscription service that delivers unique handpicked experiences. 
                  </div>
                 
                </div>
                <div
                className="missionFive"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: 25,
                  }}
                >
                  {" "}
                  <img src="../images/MissionThree.png"></img>
                </div>
              </div>
            
            </Col>
            <div
             className="storyLastText" 
            style={{
                  display:"flex",
                  alignItems:"center",
                  justifyContent:"center",
                  fontSize: "46px",
                  color: "white",
                  display: "flex",
                  fontStyle:"italic",
                  fontFamily:"Didot",
                }}>
               
                No planning, no lines, no hassle, <br/>just extraordinary memories! </div>
          </Row>
        </div>
      </div>
    </>
  );
};

export default Story;
